ScoreTrekBattle.Tournament.Series.Plan = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            active: false,
            loaded: false,
            $view: null,
            $list: null,
            focusSeriesId: null
        };
    }
    resetStatus();

    function onViewRender() {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.updateMenu('/tournament/create');
            ScoreTrekBattle.Template.renderMulti([
                'tournament/nav/tabsPlan',
                'tournament/series/list'
            ], {
                'tournament/series/list': {
                    mode: 'plan'
                }
            }).then(views => {
                var $tabs;

                $tabs = views['tournament/nav/tabsPlan'].$view;
                $tabs.find('[data-tab="tournament"]').addClass('isActive');
                $tabs.find('[data-tab="series"]').addClass('isActive');

                STATUS.active = true;
                STATUS.$view = views['tournament/series/list'].$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');

                STATUS.$view.find('[data-ref-id="club"]').remove();
                
                resolve($tabs.add(STATUS.$view));
            });
        });
    }

    function onViewLoad(seriesId) {
        return new Promise(function(resolve) {
            STATUS.active = true;
            updateList(seriesId);
            resolve();
        });
    }

    function onViewUpdate(seriesId) {
        return new Promise(function(resolve) {
            setTimeout(() => {
                if (!STATUS.$list) {
                    return;
                }
                updateList(seriesId);
            }, 0);
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function updateList(seriesId) {
        ScoreTrekBattle.View.loading('Tournament.Series.Plan.updateList', true);
        loadList().then(items => {
            renderList(items).then(() => {
                STATUS.loaded = true;
                setFocus(seriesId || STATUS.focusSeriesId);
            });
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            ScoreTrekBattle.View.loading('Tournament.Series.Plan.updateList', false);        
        });
    }

    function loadList() {
        return new Promise(function(resolve, reject) {
            STATUS.$list.addClass('loading');
            Api.request('/battle/tournament/series/all').then(result => {
                resolve(result.list);
            }).catch(reject).finally(() => {
                STATUS.$list.removeClass('loading');
            });
        });
    }

    function renderList(items) {
        return new Promise(function(resolve) {
            var promises;

            STATUS.$list.empty();
            promises = [];
            
            items.forEach(item => {
                promises.push(renderItem(item));
            });

            if (promises.length === 0) {
                promises.push(renderItem(null));
            }

            Promise.all(promises).then($items => {
                $items.forEach($item => {
                    // $item.hide();
                    STATUS.$list.append($item)
                    // $item.slideDown(400);
                });
                setTimeout(() => {
                    resolve();
                }, 400);
            });
        });
    }

    function renderItem(item) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render(item ? 'tournament/series/listItemPlan' : 'tournament/series/listItemEmpty', {series: item}, true).then(itemView => {
                if (item) {
                    itemView.$view.find('[data-id="series.tournamentsCountLabel"]').text(__i18n(`tournament/${(item.tournamentsCount === 1) ? 'single' : 'multi'}`));
                }
                resolve(itemView.$view);
            });
        });
    }

    function setFocus(seriesId) {
        STATUS.focusSeriesId = null;
        if (seriesId) {
            AnimationHandler.scrollIntoView(STATUS.$view.find(`[data-series-id="${seriesId}"]`)).then($element => {
                AnimationHandler.pulse($element);
            }).catch(ignore => {});
        }
    }

    _this = {
        focus: function(seriesId) {
            if (STATUS.loaded) {
                setFocus(seriesId);
            } else {
                STATUS.focusSeriesId = seriesId;
                setTimeout(() => {
                    if (!STATUS.$view) {
                        STATUS.focusSeriesId = null;
                    }
                }, 100);
            }
        }
    };

    ScoreTrekBattle.View.register('/series/plan', onViewRender, onViewLoad, onViewUpdate, onViewUnload, () => {
        return ScoreTrekBattle.Session.isBattleManager();
    });

    return _this;
})();